import * as React from "react";
import * as _ from "lodash";

import {RoleDto} from "../../../services/Client";

import SelectField, {SelectedValue} from "../../../components/SelectField";

export interface IRoleSelectionProps {
    /** Displayed when there's no role selected. */
    placeholder?: string;

    /** Data source array. All available roles. */
    roles: RoleDto[];

    /** Initially selected roles. */
    values?: RoleDto[];

    /** Callback when the selected roles change. */
    onChange?: (roles: RoleDto[]) => any;

    readOnly?: boolean;

    searchable?: boolean;
}

/** Return the RoleDto references from the roles array that match values. */
export const selectRoles = (roles: RoleDto[], values: RoleDto[]): RoleDto[] => (
    roles.filter(role => _.find(values, value => value.name === role.name) !== undefined)
);

/**
 * RoleSelection is a select field component enables the selection of
 * roles for UserDtos or GroupDtos. There may be 0..* roles selected.
 */
export const RoleSelection = (props: IRoleSelectionProps) => {
    const selectedValues = selectRoles(props.roles, props.values || []);
    return (
        <SelectField
            placeholder={props.placeholder}
            disabled={props.readOnly}
            multi={true}
            searchable={props.searchable}
            clearable={false}
            dataSource={props.roles}
            value={selectedValues}
            rendererKey={(role: RoleDto) => role.name}
            onChange={(selectedValue: Array<SelectedValue>) => {
                if (props.onChange) {
                    const roles = selectedValue.map(value => value.selectedValue as RoleDto);
                    props.onChange(roles);
                }
            }}
        />
    );
};

export default RoleSelection;



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/RoleSelection.tsx